<script lang="ts" setup>
import TestingView from "@/views/testing/TestingView.vue";
import type { Project } from "@/types";

// Per-project Testing tab. Reuses the same Testing unit as the top-level Testing page, scoped to this
// project: saved calls, baselines and regression suites all filter to this project's workflows.
// Available for every project type (DIY, subscriber, master) — testing is a general capability.
const props = defineProps<{ project: Project }>();
</script>

<template>
  <TestingView :project-id="props.project.id" />
</template>
